<template>
    <div
        id="be-condivisione-progetto"
        class="bg-light"
    >
        <div class="body-wrapper">
            <main class="pt-0 mt-0">

                <backend-gallery-header
                    :eventId="eventId"
                    :gallery="gallery"
                    hide-btn-share
                    hide-btn-preview
                    hide-btn-agents
                    @back="goBack"
                />

                <div class="box-condivisione">
                    <p class="mb-0 text-center">{{ isProjectShared() ? $t('Modifica condivisione') : $t('Condividi Progetto') }}: <span class="font-titoli-rikorda">{{ shareData.titolo }}</span></p>

                    <div class="d-flex my-3">
                        <div class="col-12 col-md-8 offset-md-2">
                            <div class="box-opzioni-condivisione">
                                <div class="bg-white">
                                    <h2 class="text-uppercase mb-0 text-center">{{ isProjectShared() ? $t('Modifica progetto condiviso') : $t('Imposta progetto condiviso') }}</h2>

                                    <hr>

                                    <div
                                        v-if="!isAlreadySharedInEvent()"
                                        class="info-progetto"
                                    >
                                        <div class="row align-items-center">
                                            <div class="col-5 col-md-4">
                                                {{ $t('Titolo del progetto') }}:
                                            </div>
                                            <div class="col-7 col-md-8">
                                                <input
                                                    type="text"
                                                    name="titolo"
                                                    class="form-control rounded-pill rilievo-ombra-interna"
                                                    :placeholder="$t('Titolo')"
                                                    id="titolo"
                                                    v-model="shareData.titolo"
                                                />
                                                <small
                                                    v-show="!shareData.isValidTitle"
                                                    class="text-danger"
                                                >{{ $t('Questo campo è obbligatorio') }}</small>
                                            </div>
                                        </div>
                                        <div class="row align-items-center mt-2">
                                            <div class="col-5 col-md-4">
                                                {{ $t('Prezzo al pubblico') }}:
                                            </div>
                                            <div class="col-7 col-md-8">
                                                <div class="d-flex align-items-center">
                                                    <b-input
                                                        type="number"
                                                        class="form-control rounded-pill rilievo-ombra-interna input-prezzo text-right"
                                                        min="0.00"
                                                        step="0.50"
                                                        :placeholder="$t('Imposta il prezzo')"
                                                        v-model="shareData.prezzo"
                                                        data-price="shareData.prezzo"
                                                        name="prezzo"
                                                        id="prezzo"
                                                        @change="onPriceChanged($event)"
                                                    ></b-input>
                                                    <span class="d-inline-block ml-2 font-weight-bold">€</span>
                                                </div>
                                                <small
                                                    v-show="!shareData.isValidPrice"
                                                    class="text-danger"
                                                >{{ $t("Prezzo non valido") }}</small>
                                            </div>
                                        </div>
                                    </div>

                                    <hr v-if="!isAlreadySharedInEvent()">

                                    <div class="preview-img">
                                        <div class="d-flex flex-wrap align-items-center">
                                            <div class="col-12 col-sm-6">
                                                <div class="img">
                                                    <div class="img-container w-100">
                                                        <div class="img-wrapper">
                                                            <div
                                                                v-if="isLoading"
                                                                class="loading"
                                                            />
                                                            <img
                                                                v-show="isLoaded"
                                                                :src="getProjectPreview"
                                                                @load="previewLoaded"
                                                            />
                                                        </div>
                                                        <input
                                                            ref="preview"
                                                            type="file"
                                                            accept="image/png, image/jpeg"
                                                            name="preview"
                                                            id="preview"
                                                            class="d-none"
                                                            @change.prevent="uploadPreview($event)"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div
                                                v-if="!isAlreadySharedInEvent()"
                                                class="col-12 col-sm-6 mt-3 mt-sm-0"
                                            >
                                                <div class="w-100 text-center">
                                                    <button
                                                        type="button"
                                                        class="pulsante-upload-foto btn btn-rikorda2-alt"
                                                        @click="$refs.preview.click()"
                                                    >
                                                        {{ isProjectShared() ? $t("Cambia anteprima personalizzata") : $t("Carica anteprima personalizzata") }}
                                                    </button>
                                                </div>

                                                <div
                                                    v-if="isProjectShared() || shareData.anteprima"
                                                    class="w-100 text-center mt-2"
                                                >
                                                    <button
                                                        type="button"
                                                        class="pulsante-reimposta-foto btn btn-rikorda2-alt"
                                                        @click="onRegeneratePreview()"
                                                    >
                                                        {{ $t("Reimposta anteprima") }}
                                                    </button>
                                                </div>
                                            </div>
                                            <div
                                                v-else
                                                class="col-12 col-sm-6 mt-3 mt-sm-0"
                                            >
                                                <div class="w-100 mt-2">
                                                    <div>{{ $t("Questo progetto è già condiviso con l'evento:") }}</div>
                                                    <div class="text-blurikorda font-titoli-rikorda">{{ project.eventTitle }}
                                                    </div>
                                                </div>

                                                <div class="w-100 mt-2">
                                                    <div>{{ $t("Per condividerlo nuovamente dovrai rimuoverlo dall'evento:") }}</div>
                                                    <div class="text-blurikorda font-titoli-rikorda">{{ project.eventTitle }}</div>
                                                </div>

                                                <div class="w-100 mt-2">
                                                    <div>
                                                        {{ $t("Oppure crearne un duplicato nella sezione:") }}
                                                        <a
                                                            target="_blank"
                                                            :href='getMyProjectsUrl()'
                                                        >{{ $t("I MIEI PROGETTI") }}</a>
                                                        {{ $t("del sito rikorda.it")}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="pulsanti py-3">
                                        <div
                                            class="d-flex flex-wrap"
                                            :class="{
                                                'justify-content-between': !isAlreadySharedInEvent(),
                                                'justify-content-center': isAlreadySharedInEvent()
                                                }"
                                        >
                                            <div
                                                class="col-12 col-sm-6 text-center"
                                                :class="{'text-sm-left': !isAlreadySharedInEvent()}"
                                            >
                                                <button
                                                    v-if="isProjectShared()"
                                                    type="button"
                                                    class="pulsante-interrompi-condivisione btn btn-rikorda2-alt"
                                                    @click="onRemoveProjectShare"
                                                >
                                                    {{ $t("Interrompi condivisione") }}
                                                </button>
                                                <button
                                                    v-else
                                                    type="button"
                                                    class="pulsante-annulla btn btn-rikorda2-alt"
                                                    @click="goBack"
                                                >
                                                    {{ $t("Annulla") }}
                                                </button>
                                            </div>
                                            <div
                                                v-if="!isAlreadySharedInEvent()"
                                                class="col-12 col-sm-6 text-center text-sm-right mt-2 mt-sm-0"
                                            >
                                                <button
                                                    type="button"
                                                    :class="{ 'pulsante-avvia-condivisione': !isProjectShared(), 'pulsante-salva': isProjectShared()}"
                                                    class="btn btn-rikorda1"
                                                    @click="onSaveProjectShare"
                                                >
                                                    {{ isProjectShared() ? $t("Salva modifiche") : $t("Avvia condivisione") }}
                                                </button>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <backend-footer />
        </div>
    </div>
</template>

<script>
import BackendGalleryHeader from "../../components/backend/GalleryHeader";
import BackendFooter from "../../components/backend/Footer";

export default {
    name: "BackendShareProject",

    components: {
        BackendGalleryHeader,
        BackendFooter
    },

    data() {
        return {
            eventId: "",
            project: {},
            mode: null, // mode: "edit" oppure "share"
            gallery: {},

            shareData: {
                titolo: null,
                prezzo: null,
                anteprima: null,
                isValidTitle: true,
                isValidPrice: true
            },

            isLoading: true,
            isLoaded: false,
            shareStarted: false
        };
    },

    mounted() {
        this.eventId = this.$route.params.eventId;
        this.projectId = this.$route.params.projectId;
        this.project = this.$route.params.project;
        this.mode = this.$route.params.mode;

        if (!this.project || !this.mode) {
            this.$router.push({
                name: "backend-gallery",
                params: { eventId: this.eventId }
            });
        } else {
            this.$api
                .backendGetGalleryData(this.eventId)
                .then((response) => {
                    console.log("BACKEND_GET_GALLERY_DATA", response);

                    if (response.gallery) {
                        this.gallery = response.gallery;
                    }
                })
                .catch((error) => {
                    console.error("BACKEND_GET_GALLERY_DATA", error);
                });

            this.shareData.titolo = this.project.titolo;
            this.shareData.prezzo = parseFloat(this.project.prezzo).toFixed(2);
        }
    },

    methods: {
        isProjectShared() {
            return this.mode === "edit" || this.shareStarted;
        },

        isAlreadySharedInEvent() {
            return (
                this.project &&
                this.project.eventId &&
                this.project.eventId != this.eventId
            );
        },

        onPriceChanged(event) {
            this.shareData.prezzo = parseFloat(event.replace(",", ".")).toFixed(
                2
            );
        },

        goBack() {
            if (this.isProjectShared()) {
                // torna alla gallery
                this.$router.push({
                    name: "backend-gallery",
                    params: { eventId: this.eventId, activeTab: "projects" }
                });
            } else {
                // torna alla ricerca
                this.$router.push({
                    name: "backend-gallery-search-projects",
                    params: { eventId: this.eventId }
                });
            }
        },

        uploadPreview(event) {
            let file = event.target.files[0];
            if (file) {
                this.isLoaded = false;
                this.isLoading = true;

                this.$utilsService
                    .getPreviewImageFromInput(file)
                    .then((previewImage) => {
                        if (!this.isProjectShared()) {
                            // progetto non ancora condiviso
                            this.shareData.anteprima = previewImage;
                        } else {
                            // editing progetto condiviso => invia subito l'immagine al server
                            this.$api
                                .backendSaveProjectSharePreview({
                                    eventId: this.eventId,
                                    projectId: this.projectId,
                                    previewImage: previewImage
                                })
                                .then((response) => {
                                    console.log(
                                        "BACKEND_SAVE_PROJECT_SHARE_PREVIEW",
                                        response
                                    );
                                    this.shareData.anteprima = previewImage;
                                })
                                .catch((error) => {
                                    console.error(
                                        "BACKEND_SAVE_PROJECT_SHARE_PREVIEW",
                                        error
                                    );
                                });
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            }

            event.target.value = null;
        },

        onRegeneratePreview() {
            this.isLoading = true;
            this.isLoaded = false;
            this.shareData.anteprima = "";

            if (this.isProjectShared()) {
                this.$api
                    .backendSaveProjectSharePreview({
                        eventId: this.eventId,
                        projectId: this.projectId
                    })
                    .then((response) => {
                        console.log(
                            "BACKEND_SAVE_PROJECT_SHARE_PREVIEW",
                            response
                        );
                        this.shareData.anteprima = null;
                    })
                    .catch((error) => {
                        console.error(
                            "BACKEND_SAVE_PROJECT_SHARE_PREVIEW",
                            error
                        );
                    });
            }
        },

        previewLoaded() {
            this.$nextTick(function () {
                var _that = this;
                setTimeout(function () {
                    _that.isLoaded = true;
                    _that.isLoading = false;
                }, 1000);
            });
        },

        onRemoveProjectShare() {
            const h = this.$createElement;
            this.$bvModal
                .msgBoxConfirm(
                    [
                        h("div", {}, [
                            "Stai rimuovendo il progetto dall'evento e non sarà più visibile ai tuoi clienti."
                        ]),
                        h("div", { class: ["mt-1"] }, [
                            "Non preoccuparti, se cambi idea, potrai comunque aggiungerlo nuovamente in seguito."
                        ]),
                        h("div", { class: ["mt-1"] }, ["Vuoi procedere?"])
                    ],
                    {
                        title: "Attenzione!",
                        //size: "sm",
                        okVariant: "rikorda1",
                        okTitle: "Procedi",
                        cancelTitle: "Annulla",
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true
                    }
                )
                .then((value) => {
                    // salvataggio confermato => chiamata api
                    if (value) {
                        this.$api
                            .backendRemoveProjectShare(
                                this.eventId,
                                this.projectId
                            )
                            .then((response) => {
                                console.log(
                                    "BACKEND_REMOVE_PROJECT_SHARE",
                                    response
                                );
                                this.goBack();
                            })
                            .catch((error) => {
                                console.error(
                                    "BACKEND_REMOVE_PROJECT_SHARE",
                                    error
                                );
                            });
                    }
                })
                .catch((err) => {
                    // An error occurred
                    console.error(err);
                });
        },

        onSaveProjectShare() {
            this.shareData.isValidTitle = this.shareData.titolo.length > 0;
            this.shareData.isValidPrice =
                parseFloat(this.shareData.prezzo.replace(",", ".")).toFixed(2) >
                0;

            if (this.shareData.isValidTitle && this.shareData.isValidPrice) {
                let data = {
                    eventId: this.eventId,
                    projectId: this.projectId,
                    titolo: this.shareData.titolo,
                    prezzo: this.shareData.prezzo
                };
                if (
                    this.shareData.anteprima &&
                    this.shareData.anteprima.includes("base64,")
                ) {
                    data["previewImage"] = this.shareData.anteprima;
                }

                this.shareStarted = !this.isProjectShared();
                this.$api
                    .backendSaveProjectShare(data)
                    .then((response) => {
                        console.log("BACKEND_SAVE_PROJECT_SHARE", response);
                        this.goBack();
                    })
                    .catch((error) => {
                        console.error("BACKEND_SAVE_PROJECT_SHARE", error);
                    });
            }
        },

        getMyProjectsUrl() {
            var url =
                process.env.NODE_ENV === "production"
                    ? "https://www.rikorda.it/projects"
                    : "https://www.rikorda2dev.it/projects";

            var userDataBE = this.$store.getters.userDataBE;
            if (userDataBE && userDataBE.ralid) {
                url += "?ralid=" + userDataBE.ralid;
            }

            return url;
        }
    },

    computed: {
        getProjectPreview() {
            if (this.shareData.anteprima) {
                return this.shareData.anteprima;
            } else {
                let url = this.$imagesService.getProjectUrl(
                    this.eventId,
                    this.project.idProgetto
                );

                if (url.length > 0) {
                    url += "&refresh=" + new Date().getTime();
                }
                return url;
            }
        }
    }
};
</script>

<style scoped>
.loading {
    background: transparent url("/images/icons/loading_indicator.gif") center
        no-repeat;
    background-size: 100px 100px;
    min-height: 100px;
    min-width: 100px;
}
</style>
